import { Inject, Injectable } from '@angular/core';
import { CurrentModalPayload, CurrentModalToken } from '@yourcause/common/modals';
import { AppInsightsService } from '@yourcause/common/utils';
import { Observable, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalTrackerService {
  private sub: Subscription;

  constructor (
    private appInsights: AppInsightsService,
    @Inject(CurrentModalToken) private currentModal: Observable<CurrentModalPayload>
  ) { }

  startTracking () {
    this.stopTracking();
    this.sub = this.currentModal.subscribe(async (currentModal) => {
      // Assume the modal component class has a static selector property
      const selector = (currentModal.modal as any).ɵcmp?.selectors?.[0]?.[0]
        || (currentModal.modal as any).selector
        || 'modal';

      const amendedRoute = `${location.pathname}#${selector}`;

      if (currentModal.promise) {
        this.appInsights.startTrackPage(amendedRoute);
        await currentModal.promise;
        this.appInsights.stopTrackPage(amendedRoute);
      } else {
        this.appInsights.trackPageView(amendedRoute);
      }
    });
  }

  stopTracking () {
    this.sub?.unsubscribe();
  }
}
